export default __webpack_public_path__ + "static/media/panda-2.dee20f91.png";